import { monthlyContribution } from "web_myplann/Goals/Helpers/monthlyContribution";
import { monthsUntil } from "web_myplann/Goals/Helpers/monthsUntil";

type GoalAmounts = {
	totalValue: number;
	ownFunds: number;
	loanAmount: number;
	dueDate: Date;
};

export const deriveGoalAmounts = ({
	totalValue,
	ownFunds,
	loanAmount,
	dueDate,
}: GoalAmounts) => {
	const savingsTarget = Math.max(0, totalValue - ownFunds - loanAmount);
	const realizationMode = totalValue > 0 && savingsTarget === 0;
	const hasMonthlyHero =
		!realizationMode &&
		savingsTarget > 0 &&
		monthsUntil(dueDate) > 0 &&
		monthlyContribution(savingsTarget, dueDate) > 0;

	return { savingsTarget, realizationMode, hasMonthlyHero };
};
